import { render } from "./checkbox.vue?vue&type=template&id=fbadb12c"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import "./checkbox.vue?vue&type=style&index=0&id=fbadb12c&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__